import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-education',
  templateUrl: './online-education.component.html',
  styleUrls: ['./online-education.component.scss']
})
export class OnlineEducationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
